<template>
  <div class="w_cooperation">
    <Bread :list="['设计开发平台','CMF学院']"></Bread>
    <div class="banner-main">
      <div class="banner-main-title flex">
          <div>设计开发平台</div>  
      </div>
    </div>

    <div class="main_container">
      <div class="middle-banner flex">
        <router-link :to="{ name: 'resultlist' }">CMF研究报告</router-link>
        <a href="javascript:void(0)" class="curr">CMF学院</a>
      </div>

      <CourseList></CourseList>
      
    </div>
  </div>
</template>

<script>
import CourseList from '../../components/cooperation/CourseList';
import Bread from '../../components/Common/Bread.vue'
export default {
  components:{
    CourseList,
    Bread
  }
}
</script>